export default __webpack_public_path__ + "7cd1df3a340bc13e6bfcd60548d5815b.webp";